import { defineMessages } from 'react-intl';

export default defineMessages({
  "heading": {
    "id": "landing.heading",
    "defaultMessage": "Welcome to Ret\u00FCl Passport",
    "description": "Landing page heading and title"
  },
  "intro": {
    "id": "landing.intro",
    "defaultMessage": "Access your body data and product matches with Ret\u00FCl technology.",
    "description": "Landing page heading intro"
  },
  "create_account_label": {
    "id": "landing.create_account_label",
    "defaultMessage": "Create an Account",
    "decription": "Create account button label"
  },
  "sign_in_label": {
    "id": "landing.sign_in_label",
    "defaultMessage": "Sign In",
    "decription": "Sign in button label"
  }
});



// WEBPACK FOOTER //
// ./src/client/pages/landing/messages.js